import { getProfitColumn } from '../../../../components/product-table/columns/profit-column';
import { remapColumn, type StrictColumnDef } from '../../../../components/tanstack-table/column';
import type { ProductOrderItem } from '../data/product-order-item';
import { toProduct } from '../utils';

/**
 * The last year's realized gross profit. It stays 'Annual Profit' rather than
 * the shared column's "365d Profit" because saved column layouts and the "Most
 * Profitable" sort key on the id.
 */
export const AnnualProfit: StrictColumnDef<ProductOrderItem> = remapColumn(
  getProfitColumn(365, { header: 'Annual Profit' }),
  toProduct
);
